var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 7.99992C1.33325 4.85722 1.33325 3.28587 2.30956 2.30956C3.28587 1.33325 4.85722 1.33325 7.99992 1.33325C11.1426 1.33325 12.714 1.33325 13.6903 2.30956C14.6666 3.28587 14.6666 4.85722 14.6666 7.99992C14.6666 11.1426 14.6666 12.714 13.6903 13.6903C12.714 14.6666 11.1426 14.6666 7.99992 14.6666C4.85722 14.6666 3.28587 14.6666 2.30956 13.6903C1.33325 12.714 1.33325 11.1426 1.33325 7.99992Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 5.33321,
    r: 1.33333,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 8.33338L2.50098 7.31163C3.10849 6.78006 4.0241 6.81055 4.59491 7.38136L7.45473 10.2412C7.91288 10.6993 8.63408 10.7618 9.16419 10.3892L9.36299 10.2495C10.1258 9.71343 11.1579 9.77554 11.8509 10.3993L13.9999 12.3334",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.99121a7599d29876e22869091d6a840b.svg";
export { ForwardRef as ReactComponent };